import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CategoryReferenceService extends BaseReferenceService {
  constructor() {
    super('CategoryReference');
  }
}
